import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BookingDetails from "./bookingDetails";

const HeaderSlider = ({ selectedMenu }) => {
  const images = [
    "/similing.png",
    // "driving.png",
    // "/taxib1.jpg",
 "/image 5.png",
 "taxiBanner.png"
 
    
  ];

  const settings = {
    dots: false, 
    infinite: true, 
    speed: 0, 
    autoplay: true, 
    autoplaySpeed: 5000, 
    arrows: false, 
    slidesToShow: 1, 
    slidesToScroll: 1, 
    fade: false, 
    cssEase: "none", 
  };
  return (
    <>
      <div className="w-full h-[200px] md:h-[500px] lg:h-[600px] overflow-hidden relative">
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} className="w-full h-full">
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover"
                
              />
            </div>
          ))}
        </Slider>
      </div>
      <BookingDetails selectedMenu={selectedMenu} />
    </>
  );
};

export default HeaderSlider;
